import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';

export class PrivateAPIKeySet {
  constructor(public key: string, public secret: string) { }
}

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.css']
})
export class UserLoginComponent implements OnInit {
  keySet = new PrivateAPIKeySet('', '');
  hide = true;
  errorMessage = '';
  isTerminal = false;
  constructor(
    private router: Router,
    private auth: AuthService,
    private route: ActivatedRoute
  ) {
    if (localStorage.getItem('serialId')) {
      this.isTerminal = true;
    }

  }
  ngOnInit() { }


  onSubmit() {
    // console.log(this.keySet);
    this.login();
  }

  async login() {
    const email = this.keySet.key;
    const password = this.keySet.secret;
    const result = await this.auth.login(email, password);
    if (result) {
      console.log('ログイン成功');
      this.router.navigate(['/home/history'], {relativeTo: this.route });
      this.errorMessage = '';
    } else {
      console.log('ログイン失敗');
      this.errorMessage = 'メールアドレスまたはパスワードが間違っています。';
    }
  }

  async changeTerminalMode() {
    await this.router.navigate(['/terminal']);
  }
}
